import { render, staticRenderFns } from "./activeChatAssetPreview.vue?vue&type=template&id=70785042&"
import script from "./activeChatAssetPreview.vue?vue&type=script&lang=js&"
export * from "./activeChatAssetPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports